<div
    class="eva-3-label {{ position }} {{ size }} {{ backgroundColor }}"
>
    <span class="label-container">
        <i *ngIf="isPigDeal()" class="label-icon eva-3-icon-ticket -eva-3-tc-white"></i>
        <span class="-eva-3-bold label-text -eva-3-tc-white"
            ><span *ngIf="text">-</span>{{ text }}</span
        >
    </span>
</div>
<ng-content select="[id=coupon-coachmark]"></ng-content>